<nav #header *ngIf="renderMenu" class=" fixed-top headerStyle"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}"
    style="filter: drop-shadow(1px 1px 1px #6666664d);">
    <div style="background-color: rgb(99, 27, 28);" class="contactHeader">
        <div class="container green containerHeader">
            <div class="toll">
                <span style="color: white;">TOLL FREE</span>
                <a style="text-decoration: none; padding-right: 20px;" href="tel:+18669787398" target="_blank">
                    <i class="fa fa-phone" style="padding: 0 5px;"></i>
                    +18669787398</a> |
                <a href="https://wa.me/593995603377" target="_blank">
                    <i class="fa fa-whatsapp" style="padding: 0 5px;"></i>
                    WHATSAPP</a>
            </div>
            <div>
                <a href="https://surtrek.com/es/#" target="_blank">
                    <img src="../../../../../../../../assets/images/es_round.svg" style="padding: 0 5px;"></a>
                <a href="https://surtrek.com/" target="_blank"><img
                        src="../../../../../../../../assets/images/en_round.svg" style="padding: 0 5px;"></a>
                <a href="https://surtrek.com/de/" target="_blank"><img
                        src="../../../../../../../../assets/images/de_round.svg" style="padding: 0 5px;"></a>
            </div>
        </div>
    </div>

    <div #header1 class="container green containerMenu">
        <div class="search-resp">
            <a href="https://surtrek.com">
                <i class="fa fa-search" style="font-size: 15px"></i>
            </a>
        </div>
        <div *ngIf="companyParamsService.getHasLogoInformation()" class="tooltip fade show bs-tooltip-right"
            role="tooltip" id="tooltip164687" x-placement="right"
            style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(266px, 24px, 0px);">
            <div class="arrow" style="top: 8px;"></div>
            <div class="tooltip-inner">Your Logo Here</div>
        </div>
        <a *ngIf="!this.companyParamsService.getWebSite()" class="navbar-brand" target="_blank" class="navbar-brand"
            data-container=".green" data-toggle="tooltip" data-placement="right" title="Your Logo Here">
            <img src="assets/img/logo.jpg" height="50" alt="logo" class="brand-logo">
        </a>
        <a *ngIf="this.companyParamsService.getWebSite()" href="https://surtrek.com/es/" class="navbar-brand"
            target="_blank">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().logoFade}}" id="logoFade">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().fadeMenu}}" id="fadeMenu">
            <img src="../assets/images/logos-header/st.svg" alt="logo" class="brand-logo" style="height: 60px;">
        </a>
        <div class="containerMenu navbar-collapse collapse" style="width: inherit;">
            <ul class="navbar-nav menuContainer" style="width: inherit; padding: 10px 10px 10px 0;">
                <li class="nav-item menuItem"><a href="https://surtrek.com/destinations/"
                        target="_blank">DESTINATIONS</a>
                </li>
                <li class="nav-item menuItem"><a href="https://surtrek.com/active-journeys/" target="_blank">ACTIVE
                        JOURNEYS</a></li>
                <li class="nav-item menuItem"><a href="https://galapagos.surtrek.com/" target="_blank">GALAPAGOS
                        TOURS</a></li>
                <li class="nav-item menuItem" style="background-color: rgb(235, 174, 67);"><a
                        href="https://surtrek.com/customize-your-trip/" target="_blank">PLAN YOUR TRIP</a></li>
                <li class="nav-item menuItem"><a href="https://surtrek.com/contact-us/" target="_blank">CONTACT US</a>
                </li>
            </ul>
            <div class="search" style="border-left:1px solid rgba(0,0,0,.1)">
                <a href="https://surtrek.com/es/">
                    <i class="fa fa-search" style="font-size: 15px"></i>
                </a>
            </div>
            <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                <app-heart-header></app-heart-header>
            </div>
        </div>
        <div class="container green containerHeader" style="justify-content: end; flex-direction: row!important;"
            class="responsiveHeader">
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()" style="padding-right: 3em;">
                <i class="fa fa-bars fa-2x" style="padding-right: 15px;"></i>
            </a>
        </div>

    </div>
    <ul style="width: inherit; display: none;" class="menuContainer" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem"><a href="https://surtrek.com/destinations/" target="_blank">DESTINATIONS</a>
        </li>
        <li class="nav-item menuItem"><a href="https://surtrek.com/active-journeys/" target="_blank">ACTIVE
                JOURNEYS</a></li>
        <li class="nav-item menuItem"><a href="https://galapagos.surtrek.com/" target="_blank">GALAPAGOS TOURS</a>
        </li>
        <li class="nav-item menuItem"><a href="https://galapagos.surtrek.com/galapagos-cruise-availability/"
                target="_blank">GALAPAGOS CRUISE AVAILABILITY</a></li>
        <li class="nav-item menuItem"><a href="https://surtrek.com/travel-tailored/" target="_blank">TAILOR MADE
                TRIPS</a></li>
        <li class="nav-item menuItem"><a href="https://surtrek.com/" target="_blank">GENERAL
                INFORMATION</a></li>
        <li class="nav-item menuItem"><a href="https://surtrek.com/about-us/" target="_blank">ABOUT US</a></li>
        <li class="nav-item menuItem" style="background-color: rgb(235, 174, 67);"><a
                href="https://surtrek.com/customize-your-trip/" target="_blank">PLAN YOUR TRIP</a></li>
        <li class="nav-item menuItem"><a href="https://surtrek.com/late-booking-discounts/" target="_blank">LATE BOOKING
                DISCOUNTS</a>
        <li class="nav-item menuItem"><a href="https://surtrek.com/contact-us/" target="_blank">CONTACT US</a>
        </li>
    </ul>
    <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container"
        [ngClass]="showMenu ? 'showMenu':''" style="width: inherit; display: none;">
        <app-heart-header></app-heart-header>
    </div>

</nav>